<ng-container *transloco="let t">
  <div id="esign-modal-backdrop" class="fixed inset-x-0 top-16 bottom-0 bg-white flex flex-col z-60">
    <div
      id="esign-modal-content"
      class="w-full h-full flex flex-col"
      role="dialog"
      aria-modal="true"
      aria-labelledby="esign-modal-title"
    >
      <div id="esign-modal-header" class="px-4 py-3 bg-ld-primary shrink-0">
        <div class="flex items-center gap-3">
          <button
            id="esign-close-btn"
            type="button"
            class="p-2 rounded-lg hover:bg-white/10 transition-colors cursor-pointer"
            (click)="onClose()"
            aria-label="Close and return to dashboard"
          >
            <mat-icon class="text-white!">arrow_back</mat-icon>
          </button>
          <div>
            <h2 id="esign-modal-title" class="text-lg font-dm font-semibold text-white">
              {{ t('modalsEsignTitle') }}
            </h2>
            <p class="font-dm text-sm text-white/80">{{ documentName() }}</p>
          </div>
        </div>
      </div>

      <div id="esign-modal-body" class="flex-1 min-h-0 relative overflow-hidden">
        @if (isLoading()) {
          <div class="absolute inset-0 flex items-center justify-center bg-white">
            <div class="flex flex-col items-center gap-4">
              <mat-spinner diameter="48"></mat-spinner>
              <p class="font-dm text-sm text-ld-neutral-500">{{ t('modalsEsignLoading') }}</p>
            </div>
          </div>
        }

        @if (usingInAppBrowser()) {
          <div class="absolute inset-0 flex items-center justify-center bg-ld-neutral-50">
            <div class="flex flex-col items-center gap-4 text-center px-6 max-w-md">
              <div class="size-16 rounded-full bg-ld-primary-50 flex items-center justify-center">
                <mat-icon class="text-ld-primary text-3xl!">open_in_browser</mat-icon>
              </div>
              <h3 class="font-dm text-lg font-semibold text-ld-neutral">{{ t('modalsEsignBrowserOpenedTitle') }}</h3>
              <p class="font-dm text-sm text-ld-neutral-500">{{ t('modalsEsignBrowserOpenedMessage') }}</p>
              <p class="font-dm text-xs text-ld-neutral-400">{{ t('modalsEsignBrowserOpenedHint') }}</p>
            </div>
          </div>
        }

        @if (hasError()) {
          <div class="absolute inset-0 flex items-center justify-center bg-white">
            <div class="flex flex-col items-center gap-4 text-center px-6">
              <div class="size-16 rounded-full bg-red-100 flex items-center justify-center">
                <img [src]="errorIcon" alt="Error" class="w-8 h-8" />
              </div>
              <h3 class="font-dm text-lg font-semibold text-ld-neutral">{{ t('modalsEsignErrorTitle') }}</h3>
              <p class="font-dm text-sm text-ld-neutral-500">{{ errorMessage() || t('modalsEsignErrorMessage') }}</p>
              <button
                type="button"
                class="px-6 py-2.5 text-sm font-dm font-semibold text-white bg-ld-primary rounded-lg hover:bg-ld-primary-600 transition-colors cursor-pointer"
                (click)="onClose()"
              >
                {{ t('commonAriaClose') }}
              </button>
            </div>
          </div>
        }

        @if (isDocutechFlow()) {
          <iframe
            id="esign-iframe"
            name="ESIGN_DOCUTECH_IFRAME"
            class="absolute inset-0 w-full h-full border-0"
            [class.invisible]="isLoading() || hasError()"
            (load)="onIframeLoad()"
            (error)="onIframeError()"
            title="E-Sign Document"
            allow="camera; microphone; storage-access"
          ></iframe>

          <form #esignForm id="esign-token-form" method="POST" target="ESIGN_DOCUTECH_IFRAME" class="hidden">
            <input type="hidden" name="access_token" />
          </form>
        } @else {
          <iframe
            id="esign-iframe"
            [src]="safeUrl()"
            class="absolute inset-0 w-full h-full border-0"
            [class.invisible]="isLoading() || hasError()"
            (load)="onIframeLoad()"
            (error)="onIframeError()"
            title="E-Sign Document"
            allow="camera; microphone; storage-access"
          ></iframe>
        }
      </div>
    </div>
  </div>
</ng-container>
